// Sidebar.js
import {
  defineComponent,
  ref,
  computed,
  watch,
  inject,
} from "/Scripts/vue.esm-browser.js";
const html = String.raw;
export default defineComponent({
  name: "Sidebar",
  props: {
    user: {
      type: String,
    },
  },
  emits: [],
  setup(props, { emit }) {
    const historyDialogPopup = inject("historyDialogPopup", ref(false));
    const getHistoryData = inject("getHistoryData");
    const web = inject("web");

    //取得歷史資料
    const getHistory = async () => {
      const aryMainGroupCode =
        JSON.parse(localStorage.getItem("viewedGroups")) || [];
      if (aryMainGroupCode.length > 0) {
        await getHistoryData(aryMainGroupCode.join("|"));
      }

      historyDialogPopup.value = true;
    };
    const b2bLogout = () => {
      var random = generateRandomString(20, 16, "x");
      $.ajax({
        type: "POST",
        url: "/action/public/session.asp?utm_projectid=" + random,
        success: function (response) {
          // The request was successful, and the response is available in the 'response' variable
          //console.log(response);
          SubmitPost("/Member/Logout");
        },
        error: function (error) {
          console.error("Error:", error);
        },
      });
    };
    const topFunction = () => {
      $("html, body").animate({ scrollTop: 0 }, 1000); // 1000 毫秒即 1 秒的動畫時間
      return false;
    };
    return { getHistory, topFunction, web, b2bLogout };
  },
  template: html`
    <div id="wrapperhead" class="main_sidebar">
      <div class="ms_top">
        <span class="user_name" v-if="web=='b2b'"> {{user}} </span>
        <span class="logout" @click="b2bLogout" v-if="web=='b2b'">登出</span>
      </div>
      <div class="ms_bottom">
        <ul class="main_sidebar_ul">
          <li class="ms_item_list product_history_btn">
            <a href="javascript:void(0)" @click="getHistory">
              <div class="ms_item-view">
                <img
                  loading="lazy"
                  src="/Content/Img/Shop/icon_visibility.png"
                  alt=""
                />
              </div>
              <span class="list-name">
                <p>查看</p>
                <p>紀錄</p>
              </span>
            </a>
          </li>
          <li class="ms_item_list print_btn" style="display: none">
            <a href="javascript:void(0)">
              <div class="ms_item-print">
                <img
                  loading="lazy"
                  src="/Content/Img/Tour/sidebar_print_unselected.png"
                  alt=""
                />
              </div>
              <span class="list-name">
                <p>列印</p>
                <p>行程</p>
              </span>
            </a>
          </li>

          <li class="ms_item_list ContactShare_btn">
            <a href="javascript:void(0)">
              <div class="ms_item-contact">
                <img
                  loading="lazy"
                  src="/Content/Img/Tour/sidebar_contact_unselected.png"
                  alt=""
                />
              </div>
              <span class="list-name">
                <p>聯絡</p>
                <p>我們</p>
              </span>
            </a>
            <div class="ms_item_list_ol">
              <ol class="ms_item_list_ol-list">
                <li class="ms_list-contact">
                  <a href="https://line.me/R/ti/p/%40bestwaytravel">
                    <div class="ms_item-contact-line">
                      <img
                        loading="lazy"
                        src="/Content/Img/Tour/contact_line.png"
                        alt=""
                      />
                    </div>
                    <span class="list-detail-name">
                      LINE
                      <br />
                      客服
                    </span>
                  </a>
                </li>
                <li class="ms_list-contact">
                  <a
                    href="https://m.facebook.com/messages/thread/456800857725204"
                  >
                    <div class="ms_item-contact-fb">
                      <img
                        loading="lazy"
                        src="/Content/Img/Tour/contact_fb.png"
                        alt=""
                      />
                    </div>
                    <span class="list-detail-name">
                      FB
                      <br />
                      私訊
                    </span>
                  </a>
                </li>
                <li class="ms_list-contact">
                  <a href="https://www.bwt.com.tw/Company/Store">
                    <div class="ms_item-contact-store">
                      <img
                        loading="lazy"
                        src="/Content/Img/Tour/contact_store.png"
                        alt=""
                      />
                    </div>
                    <span class="list-detail-name">
                      門市
                      <br />
                      電話
                    </span>
                  </a>
                </li>
              </ol>
            </div>
            <div class="contactWindow-m">
              <div class="windows_close-m">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M1.6 16L0 14.4L6.4 8L0 1.6L1.6 0L8 6.4L14.4 0L16 1.6L9.6 8L16 14.4L14.4 16L8 9.6L1.6 16Z"
                    fill="#6F87A1"
                  ></path>
                </svg>
              </div>
              <div class="contactList-m">
                <div>
                  聯絡
                  <br />
                  我們
                </div>
                <ul class="contactListDetail-m">
                  <li>
                    <a href="https://line.me/R/ti/p/%40bestwaytravel">
                      <div class="contact-line-m">
                        <img
                          loading="lazy"
                          src="/Content/Img/Tour/contact_line.png"
                          alt=""
                        />
                      </div>
                      <div class="list-detail-name-m">LINE</div>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://m.facebook.com/messages/thread/456800857725204"
                    >
                      <div class="contact-fb-m">
                        <img
                          loading="lazy"
                          src="/Content/Img/Tour/contact_fb.png"
                          alt=""
                        />
                      </div>
                      <div class="list-detail-name-m">FB</div>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.bwt.com.tw/Company/Store">
                      <div class="contact-store-m">
                        <img
                          loading="lazy"
                          src="/Content/Img/Tour/contact_store.png"
                          alt=""
                        />
                      </div>
                      <div class="list-detail-name-m">找門市</div>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="contactList-m">
                <div>
                  分享
                  <br />
                  資訊
                </div>
                <ul class="contactListDetail-m">
                  <li>
                    <a
                      href="https://timeline.line.me/social-plugin/share?url=https://www.bwt.com.tw/"
                    >
                      <div class="share-line-m">
                        <img
                          loading="lazy"
                          src="/Content/Img/Tour/share_line.png"
                          alt=""
                        />
                      </div>
                      <div class="list-detail-name-m">LINE</div>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https://www.bwt.com.tw/"
                    >
                      <div class="share-fb-m">
                        <img
                          loading="lazy"
                          src="/Content/Img/Tour/share_fb.png"
                          alt=""
                        />
                      </div>
                      <div class="list-detail-name-m">FB</div>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <div class="share-link-m">
                        <img
                          loading="lazy"
                          src="/Content/Img/Tour/share_link.png"
                          alt=""
                        />
                      </div>
                      <div class="list-detail-name-m">複製連結</div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li class="ms_item_list ms_item_list-share ContactShare_btn">
            <a href="javascript:void(0)">
              <div class="item-share">
                <img
                  loading="lazy"
                  src="/Content/Img/Tour/sidebar_share_unselected.png"
                  alt=""
                />
              </div>
              <span class="list-name">
                <p>分享</p>
                <p>資訊</p>
              </span>
            </a>
            <div class="ms_item_list_ol">
              <ol class="ms_item_list_ol-list">
                <li class="list-share">
                  <a
                    href="https://timeline.line.me/social-plugin/share?url=https://www.bwt.com.tw/"
                  >
                    <div class="item-share-line">
                      <img
                        loading="lazy"
                        src="/Content/Img/Tour/share_line.png"
                        alt=""
                      />
                    </div>
                    <span class="list-detail-name"> LINE </span>
                  </a>
                </li>
                <li class="list-share">
                  <a
                    href="https://www.facebook.com/sharer/sharer.php?u=https://www.bwt.com.tw/"
                  >
                    <div class="item-share-fb">
                      <img
                        loading="lazy"
                        src="/Content/Img/Tour/share_fb.png"
                        alt=""
                      />
                    </div>
                    <span class="list-detail-name">FB</span>
                  </a>
                </li>
                <li class="list-share">
                  <a href="javascript:void(0)">
                    <div class="item-share-link">
                      <img
                        loading="lazy"
                        src="/Content/Img/Tour/share_link.png"
                        alt=""
                      />
                    </div>
                    <span class="list-detail-name">
                      <p>複製</p>
                      <p>連結</p>
                    </span>
                  </a>
                </li>
              </ol>
            </div>
          </li>

          <li class="ms_item_list toplist" v-if="['b2c','m'].includes(web)">
            <a href="javascript:void(0)">
              <div class="item-compare">
                <img
                  loading="lazy"
                  src="/Content/Img/Tour/sidebar_compare_unselected.png"
                  alt=""
                />
                <span id="TopFavListCount" class="clt-nb-top"> 1 </span>
              </div>
              <span class="list-name">
                <p>最愛</p>
                <p>清單</p>
              </span>
            </a>
            <div id="TopFavCollect" class="collect">
              <div class="TopFavCollect_main">
                <div class="windows_close li-windows_close">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M1.6 16L0 14.4L6.4 8L0 1.6L1.6 0L8 6.4L14.4 0L16 1.6L9.6 8L16 14.4L14.4 16L8 9.6L1.6 16Z"
                      fill="#6F87A1"
                    ></path>
                  </svg>
                </div>

                <div class="collect_title">
                  <div class="collect_title_img">
                    <img
                      loading="lazy"
                      src="/Content/Img/Tour/sidebar_compare_blue.png"
                      alt=""
                    />
                  </div>
                  <div>比較清單</div>
                </div>
                <div class="mCustomScrollBox">
                  <ul class="mCSB_container" id="mCSB_1_container"></ul>
                </div>
                <a href="//www.bwt.com.tw/Search/Compare" class="seeall">
                  <span>查看全部</span>
                </a>
                <div class="TopFavCollect_decorate">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="32"
                    viewBox="0 0 28 32"
                    fill="none"
                  >
                    <path
                      d="M8.09166 2.32034C9.44441 0.116987 12.5007 -0.243447 14.3289 1.58476L26.041 13.2969C27.6031 14.859 27.6031 17.3916 26.041 18.9537L14.5377 30.457C12.6834 32.3113 9.57629 31.9096 8.25453 29.6447L1.20697 17.5682C0.463821 16.2948 0.481473 14.7158 1.25291 13.4593L8.09166 2.32034Z"
                      fill="#FDFDFD"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
          </li>

          <li class="ms_item_list sidebar_top_btn" id="sidebar_top">
            <button class="ms_top-button" type="button" @click="topFunction">
              <div class="item-top">
                <img
                  loading="lazy"
                  src="/Content/Img/Tour/sidebar_Top.png"
                  alt=""
                />
              </div>
              <span class="list-name">
                <p>top</p>
              </span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  `,
  methods: {},
});
